import React from "react";

function Card({ children }) {
  return (
    <div className="pt-13 min-h-screen rounded-lg bg-white p-10 leading-normal shadow-md md:min-h-0 md:bg-card md:bg-right-bottom md:bg-no-repeat lg:min-h-[483px] lg:w-[840px]">
      {children}
    </div>
  );
}

export default Card;
